<fuse-drawer
  class="w-screen min-w-screen sm:w-100 sm:min-w-100 z-999"
  fixed
  [mode]="mode()"
  [name]="'mainDrawer'"
  [position]="position()"
  [opened]="isOpen()"
  [class]="drawerClasses()"
  (openedChanged)="onDrawerOpened($event)"
  [showCloseButton]="false"
  [sizeType]="sizeType()"
  [showUpBand]="true"
  transparentOverlay
  #mainDrawer>

  <!-- Drawer Header -->
  @if (title()) {
    <mat-toolbar>
      <div class="flex flex-row justify-between w-full">
        <div class="flex flex-col justify-start w-full">

          @if (title()) {
            <h2 class="text-2xl font-semibold">{{ title() }}</h2>
          }
          @if (subtitle()) {
            <p class="text-sm text-slate-600">{{ subtitle() }}</p>
          }
        </div>

        @if (canClose()) {
          <button
            mat-icon-button
            class="drawer-close-button"
            (click)="onClose()"
            [disabled]="loading()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </mat-toolbar>
    <mat-divider></mat-divider>
  }

  <!-- Loading State -->
  @if (loading()) {
    <div class="drawer-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading...</p>
    </div>
  }

  <!-- Drawer Content -->
  @if (hasContent() && !loading()) {
    <div class="drawer-content">
      @switch (content()?.type) {
        @case ('loaded-quote-request') {
          <accordion-quote-request-view
            (quoteUpdated)="quoteSelectionEvent($event)"
            [displayMode]="content()?.data?.display_mode"
            [item]="content()?.data"></accordion-quote-request-view>
        }
        @default {
          <div class="default-content">
            <!-- Default content -->
            <div class="content-placeholder">
              <h3>Default Content</h3>
              <p>No specific content type defined</p>
            </div>
          </div>
        }
      }
    </div>

    @if (hasContent() && !loading()) {
      @switch (content()?.type) {
        @case ('loaded-quote-request') {
          <!--TODO I need to use the common drawer footer / Add to the config ability to handle anchors-->
          <div class="absolute bottom-0 left-0 right-0 flex justify-center mb-4">
            <a [href]="content()?.data?.v2_link"
               mat-flat-button
               color="primary"
               class="bg-primary text-white p-2 rounded-full"
               target="_blank">
              Go to Quote Request
            </a>
          </div>
        }
      }
    }
  }

</fuse-drawer>
